const config = {
  api: {
    baseUrl: 'https://d63610hide.execute-api.ap-southeast-2.amazonaws.com/default'
  }
}

export default config
